<div class="page-wrapper">
  <div class="reference-master-form">
    <div class="form-header">
      <h3>{{ appservice.isedit ? 'Edit Reference' : 'Add Reference' }}</h3>
    </div>

    <form [formGroup]="referenceEditForm" (ngSubmit)="onSaveReference()">
      <div formGroupName="add">
        <!-- <div class="form-row">
          <label for="code">Reference Code</label>
          <div class="code-input-wrap">
            
            <input
              id="code"
              class="form-control"
              type="text"
              formControlName="RM_code"
              placeholder="Enter code"
              [(ngModel)]="add.RM_code"
            />
          </div>
        </div> -->

        <div class="form-row">
          <label for="type">Type</label>
          <select id="type" class="form-select" formControlName="REM_REFid">
            <option value="">-- Select Type --</option>
            <option *ngFor="let type of referenceTypes" [value]="type.RG_iid">
              {{ type.RG_Name }}
            </option>
          </select>

  
        </div>

        <div class="form-row">
          <label for="description">Description</label>
          <input
            id="description"
            class="form-control"
            type="text"
            formControlName="REM_REF_Name"
            placeholder="Enter description"
               
          />
        </div>
      </div>

      <div class="form-actions">
        <button type="submit" class="btn btn-success" [disabled]="isSaving">
          {{ isSaving ? 'Saving...' : 'Save' }}
        </button>
        <button type="button" class="btn btn-secondary" (click)="onCancel()" [disabled]="isSaving">
          Cancel
        </button>
        <span class="save-message">{{ saveMessage }}</span>
      </div>
    </form>
  </div>
</div>
